import {isNilOrEmpty} from 'ramda-adjunct';

import {VehicleAudit} from '../api/digitalCertificateApi';
import {SectionId} from '../consts/Sections';
import {SlideVideo} from '../types/SlideVideo';
import {getVideosByKeys} from '../utils/getVideosByKeys';

export type VideoWalkthroughDataBundle = {
  videoWalkthroughVideos: SlideVideo[];
  sectionConfig: {
    name: SectionId;
    isHidden: boolean;
  };
};
export const useGetDataForVideoWalkthrough = (
  vehicleAudit: VehicleAudit | null | undefined
): VideoWalkthroughDataBundle => {
  const videoWalkthroughVideos = getVideosByKeys({
    vehicleAudit,
    uniqueKey: 'VIDEOS',
    parentUniqueKey: 'VIDEO_WALKTHROUGH',
  });

  const shouldBeFeaturesHidden = isNilOrEmpty(videoWalkthroughVideos);

  return {
    videoWalkthroughVideos: videoWalkthroughVideos ?? [],
    sectionConfig: {
      isHidden: shouldBeFeaturesHidden,
      name: 'VIDEO_WALKTHROUGH',
    },
  };
};
